module.exports = __webpack_public_path__ + "2741a14e49524efa6059c735010239d0.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Medium.woff2
// module id = 347
// module chunks = 0